export default "__VITE_ASSET__CqnJI3EJ__"